// ag-grid-enterprise v21.2.2
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function naturalOrder(a, b) {
  return a - b;
}

exports.naturalOrder = naturalOrder;